import { get } from "lodash";
import htmlToFormattedText from "html-to-formatted-text";

export const issueListParams = {
  limit: 10,
  offset: 0,
  projectGroupBy: true
};

export const modifyDataForPost = data => {
  return {
    comment: htmlToFormattedText(get(data, "comment")),
    fids: get(data, "files", []).map(value => {
      return +value.id;
    }),
    issueId: get(data, "id")
  };
};
